export default [
  /* {
    path: 'billing/create/:view',
    name: 'new-billing',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/materialsRequests/components/CreateMaterialsRequests')
  }, */
  {
    path: 'billing/:view',
    name: 'billing',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/billing/vistas/Billing')
  }
];
